<template lang="pug">
.template-judge-item-component
  .section-and-group(v-if="isSection(value)" :class="_margin")
    //- type: section
    .template-item.d-flex.flex-column(v-if="isSection(value)")
      .d-flex.flex-row
        .section-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .section-text(v-if="value.text" v-html="formatTextWithLink(value.text)")
      .section-text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
      .section-text.warning-message(v-if="value.displayToUser == false") 本項目は施設のみ入力可能な項目です
      .mb-2
      .section-items
        .section-item(v-for="(property, index) in value.properties" :key="property.id")
          WaiterJudgeTemplateInputItem(v-model="value.properties[index]" :isChaild="true")

  .template-items(v-else).mr-3.mb-3.ml-3
    //- type: text
    .template-item.d-flex.flex-column(v-if="isText(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
        span.warning-message(v-if="value.displayToUser == false") 本項目は施設のみ入力可能な項目です

      .d-flex.flex-row.align-items-center(v-if="value.prefix || value.suffix")
        .text-prefix.mr-2(v-if="value.prefix") {{ value.prefix }}
        b-form-input(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :min="value.min" :max="value.max"
          :minlength="value.minlength" :maxlength="value.maxlength" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
          v-validate="createValidateRules(value)" data-vv-as="本項目" :style="getTextStyle(value)")
        .text-suffix.ml-2 {{ value.suffix }}
      div(v-else)
        b-form-input(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :min="value.min" :max="value.max"
          :minlength="value.minlength" :maxlength="value.maxlength" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
          v-validate="createValidateRules(value)" data-vv-as="本項目" :style="getTextStyle(value)")
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: radio
    .template-item.d-flex.flex-column(v-if="isRadio(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
        span.warning-message(v-if="value.displayToUser == false") 本項目は施設のみ入力可能な項目です

      template
        b-table-simple.dark-boder-table.waiter-judge-template-table
          b-tbody
            b-tr(v-for="(option, index) in value.options" :key="index")
              b-td.no.text-center(:class="{ 'radio-selected': isRadioChecked(option, value.answer) }")
                span {{ index + 1 }}
              b-td.radio(:class="{ 'radio-selected': isRadioChecked(option, value.answer) }")
                .radio-item(v-if="index == 0")
                  b-form-radio(v-model="value.answer" :name="value.id" :value="option.value" v-validate="createValidateRules(value)" data-vv-as="本項目") {{ option.text }}
                .radio-item(v-else)
                  b-form-radio(v-model="value.answer" :name="value.id" :value="option.value") {{ option.text }}
              b-td.point.text-center(v-if="value.showPoint == true" :class="{ 'radio-selected': isRadioChecked(option, value.answer) }")
                span(v-if="option.point") {{ option.point }}点
                span(v-else) －
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: radioGroup
    .template-item-radio-group.d-flex.flex-column(v-if="isRadioGroup(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
        span.warning-message(v-if="value.displayToUser == false") 本項目は施設のみ入力可能な項目です
      
      .radio-items.mb-2(v-for="(property, index) in value.properties" :key="value.id + '-' + index")
        .radio-item(v-if="index == 0")
          b-form-radio(v-model="value.answer" :name="value.id" :value="property.option.value" v-validate="createValidateRules(value)" data-vv-as="本項目") {{ property.option.text }}
        .radio-item(v-else)
          b-form-radio(v-model="value.answer" :name="value.id" :value="property.option.value") {{ property.option.text }}

        .radio-properties.pt-2.mt-2(v-if="property.properties && 0 < property.properties.length && value.answer == property.option.value")
          .group-child-item(v-for="(childProperty, childIndex) in property.properties" :key="value.id + '-' + index + '-' + childIndex")
            WaiterJudgeTemplateInputItem(v-model="value.properties[index].properties[childIndex]" :isChaild="true")
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}
        
    //- type: multipleCheckbox
    .template-item-multiple-checkbox.d-flex.flex-column(v-if="isMultipleCheckbox(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
        span.warning-message(v-if="value.displayToUser == false") 本項目は施設のみ入力可能な項目です

      template
        b-table-simple.dark-boder-table.waiter-judge-template-table
          b-tbody
            b-tr(v-for="(question, index) in value.questions" :key="index")
              b-td.no.text-center(:class="{ 'checkbox-selected': isMultipleCheckboxChecked(value, index) }")
                span {{ index + 1 }}
              b-td.radio(:class="{ 'checkbox-selected': isMultipleCheckboxChecked(value, index) }")
                b-form-checkbox(:id="value.id + '-' + index" v-model="value.answer[index]" :name="value.id + '-' + index"
                  :value="true" :unchecked-value="false" data-vv-as="本項目") {{ value.questions[index] }}
              b-td.point.text-center(v-if="value.showPoint == true" :class="{ 'checkbox-selected': isMultipleCheckboxChecked(value, index) }")
                span(v-if="value.points[index]") {{ value.points[index] }}点
                span(v-else) －

      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { TemplateItem, TemplateType, TemplateItemInput, TemplateItemText } from "@/commons/services/AdmissionApplicationTemplates";

import HelpIcon from "@/pc/basics/HelpIcon.vue";
import ChildTemplateItem from "@/pc/containers/waiters/WaiterJudgeTemplateInputItem.vue";
import { RadioOption, TemplateItemMultipleCheckbox } from "@/commons/services/AdmissionJudgementTemplates";

/**
 * ### 待機者登録画面コンポーネント
 */
@Component({
  components: {
    HelpIcon,
    ChildTemplateItem
  },
  // 再帰呼び出しする場合、proビルド時にコンポーネント名が書き換えられて動かなくなるので明示的に定義する
  name: "WaiterJudgeTemplateInputItem"
})
export default class WaiterJudgeTemplateInputItem extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  /** テンプレート情報 */
  @Prop({ required: true })
  value!: TemplateItem;

  /** 子要素かどうか */
  @Prop({ required: true })
  isChaild!: boolean;

  get _margin(): string[] {
    if (this.isChaild == true) {
      return ["mr-3", "mb-3", "ml-3"];
    } else {
      return [""];
    }
  }

  /**
   * テキスト内の Markdown リンク記法 `link` を `<a>` タグに変換します。
   * クロスサイトスクリプティング（XSS）対策として、タグ変換前に HTML エスケープを行います。
   */
  public formatTextWithLink(text: string | undefined): string {
    if (!text) {
      return "";
    }

    // HTMLエスケープ処理
    let escapedText = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");

    // Markdown リンク テキスト を <a> タグに変換
    const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
    return escapedText.replace(linkRegex, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  }

  public isSection(item: TemplateItem): boolean {
    if (item.type != TemplateType.SECTION) {
      return false;
    }
    return true;
  }

  public isText(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEXT) {
      return false;
    }
    return true;
  }

  public getTextStyle(item: TemplateItemText): string {
    if (!item.width) {
      return "";
    }
    return `width:${item.width}px;`;
  }

  public isRadio(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO) {
      return false;
    }
    return true;
  }

  public isRadioChecked(option: RadioOption, answer: string): boolean {
    if (option.value == answer) {
      return true;
    }
    return false;
  }

  public isRadioGroup(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO_GROUP) {
      return false;
    }
    return true;
  }

  public isMultipleCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.MULTIPLE_CHECKBOX) {
      return false;
    }
    return true;
  }

  public isMultipleCheckboxChecked(item: TemplateItemMultipleCheckbox, index: number): boolean {
    if (!item) {
      return false;
    }
    return item.answer[index] ? item.answer[index] : false;
  }

  public isRequired(item: TemplateItemInput): boolean {
    if (item.validationRules == null) {
      return false;
    }

    for (const validationRule of item.validationRules) {
      if (validationRule == "required") {
        return true;
      }
    }
    return false;
  }

  public createValidateRules(item: TemplateItem): any {
    let rules: any = {};

    // itemの保持するルールをオブジェクト化する
    const inputItem: TemplateItemInput = item as TemplateItemInput;

    if (inputItem.validationRules == null) {
      return false;
    }

    for (const rule of inputItem.validationRules) {
      const splitedRule: string[] = rule.split(":");
      if (splitedRule.length == 1) {
        rules[`${splitedRule[0]}`] = true;
      } else {
        rules[`${splitedRule[0]}`] = splitedRule[1];
      }
    }

    // ファイル種別毎のルールを追加する
    switch (item.type) {
      case TemplateType.TEXT:
      case TemplateType.RADIO:
      case TemplateType.RADIO_GROUP: {
        break;
      }
      default: {
        return {};
      }
    }

    return rules;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.template-judge-item-component {
  .section-label,
  .item-label {
    font-weight: bold;
  }

  .section-text,
  .text {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
  .noinput {
    background-color: $bg-require-input !important;
    &::placeholder {
      color: rgb(117, 117, 117);
    }
  }

  .template-item-radio-group {
    .radio-properties {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }
  }

  .radio-selected,
  .checkbox-selected {
    font-weight: bold;
    background-color: $bg-calendar-current-date;
  }
}
</style>
